import type { JournalHoldingsTreeIssue, JournalHoldingsTreeItem } from "@/lib/api/catalog";
import { formatAccessionNumber } from "@/lib/utils/catalog-formatting";

function CopyRows({ items }: { items: JournalHoldingsTreeItem[] }) {
  if (items.length === 0) {
    return <p className="px-4 py-3 text-sm text-muted-foreground">No copies received.</p>;
  }

  return (
    <ul className="divide-y" aria-label="Copies">
      {items.map((item) => {
        const location = item.location?.name;
        return (
          <li key={item.id} className="grid gap-1 px-4 py-3 text-sm sm:grid-cols-2 lg:grid-cols-4">
            <span>
              <span className="text-muted-foreground">Accession: </span>
              {formatAccessionNumber(item.accessionNumber) || item.accessionNumber}
            </span>
            <span>
              <span className="text-muted-foreground">Barcode: </span>
              <span className="font-mono">{item.barcode}</span>
            </span>
            <span>
              <span className="text-muted-foreground">Status: </span>
              {item.statusCode}
            </span>
            {location ? (
              <span>
                <span className="text-muted-foreground">Location: </span>
                {location}
              </span>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}

export function JournalHoldingRows({ issues }: { issues: JournalHoldingsTreeIssue[] }) {
  if (issues.length === 0) {
    return <p className="px-4 py-5 text-sm text-muted-foreground">No issues or copies received.</p>;
  }

  return (
    <div className="divide-y">
      {issues.map((issue) =>
        issue.isDefault ? (
          <CopyRows key={issue.id} items={issue.items} />
        ) : (
          <section key={issue.id} aria-labelledby={`issue-${issue.id}`}>
            <div className="space-y-1 bg-muted/40 px-4 py-2">
              <h4 id={`issue-${issue.id}`} className="font-medium">
                <span className="text-muted-foreground">Issue: </span>
                {issue.issueLabel}
              </h4>
              {issue.publicationDate ? (
                <p className="text-xs text-muted-foreground">
                  Publication date: {issue.publicationDate}
                </p>
              ) : issue.publicationYear ? (
                <p className="text-xs text-muted-foreground">
                  Publication year: {issue.publicationYear}
                </p>
              ) : null}
            </div>
            <CopyRows items={issue.items} />
          </section>
        )
      )}
    </div>
  );
}
